export default "__VITE_ASSET__BXkKZdeM__"